export const datatableComponents = {
  SocioQuestionnaireTable: () => import("./SocioQuestionnaireTable.vue"),
};
